import { type PropsWithChildren, useRef } from 'react';

import { createStore, type Store } from '../../../core/store/store.js';
import { INITIAL_HOVER_STATE } from '../constants.js';
import { SankeyHoverStoreContext } from '../context/SankeyHoverStore.context.js';
import type { SankeyHoverState } from '../types/sankey-hover.js';

export const SankeyHoverStoreProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<Store<SankeyHoverState> | null>(null);

  storeRef.current ??= createStore(INITIAL_HOVER_STATE);

  return (
    <SankeyHoverStoreContext.Provider value={storeRef.current}>
      {children}
    </SankeyHoverStoreContext.Provider>
  );
};

SankeyHoverStoreProvider.displayName = 'SankeyHoverStoreProvider';
